import ListaMarketing from "../componentes/ListaMarketing.vue";

const routes = [
    ...route("/lista-marketing-tfg", ListaMarketing, {
        Auth: true,
        alicante: false,

        //req_admin: true
    }),
    ...route("/lista-marketing-tfg-alicante", ListaMarketing, {
        Auth: true,
        alicante: true,
        //req_admin: true
    }),
];

function route(path, component = Default, meta = {}) {
    return [
        {
            path,
            component,
            meta,
        },
    ];
}

export default routes;
